var map = {
	"./onto-cookie-consent_2.entry.js": [
		60560,
		60560
	],
	"./onto-dialog_2.entry.js": [
		78681,
		78681
	],
	"./onto-dropdown.entry.js": [
		18961,
		46981,
		18961
	],
	"./onto-footer_5.entry.js": [
		7815,
		46981,
		7815
	],
	"./onto-language-selector_9.entry.js": [
		82206,
		82206
	],
	"./onto-layout.entry.js": [
		39874,
		39874
	],
	"./onto-permission-banner.entry.js": [
		60730,
		60730
	],
	"./onto-test-context.entry.js": [
		20694,
		20694
	],
	"./translate-label.entry.js": [
		45758,
		45758
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65539;
module.exports = webpackAsyncContext;